import { forwardRef, useMemo } from "react";
import { Clock } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * TimePicker — HH:MM format input (24h).
 * Faza 5 Sprint 7. Native <input type="time"> ustiga shadcn-stil qoplama.
 */
export interface TimePickerProps {
  value: string; // "HH:MM"
  onChange: (value: string) => void;
  disabled?: boolean;
  invalid?: boolean;
  className?: string;
  id?: string;
  /** 5/15/30 daqiqa step (default 30) */
  step?: 5 | 15 | 30 | 60;
}

const HOURS = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0"));

export const TimePicker = forwardRef<HTMLInputElement, TimePickerProps>(
  function TimePicker(
    { value, onChange, disabled, invalid, className, id, step = 30 },
    ref,
  ) {
    const isValid = useMemo(() => /^\d{2}:\d{2}$/.test(value), [value]);
    void isValid;
    void HOURS;

    return (
      <div
        className={cn(
          "relative flex items-center h-11 rounded-lg border bg-zinc-950/60 px-3 transition-colors",
          "border-zinc-800",
          "focus-within:border-[color:var(--brand-primary)]/60 focus-within:ring-2 focus-within:ring-[color:var(--brand-primary)]/30",
          invalid && "border-[color:var(--danger)]/70 focus-within:border-[var(--danger)] focus-within:ring-[color:var(--danger)]/30",
          disabled && "opacity-60 pointer-events-none",
          className,
        )}
      >
        <Clock className="h-4 w-4 text-[var(--text-muted)] mr-2 shrink-0" aria-hidden />
        <input
          ref={ref}
          id={id}
          type="time"
          step={step * 60}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={cn(
            "flex-1 bg-transparent text-sm text-zinc-100 placeholder:text-zinc-500 outline-none",
            "[color-scheme:dark]",
          )}
        />
      </div>
    );
  },
);
